import { CardContainer, CardBody, CardItem } from "./UI/3d-card";
import React from "react";
import motionimg from "../assets/motionimg.png";

const MotionCard = () => {
  return (
    <CardContainer className="inter-var mr-8">
      <CardBody className="bg-gray-50 relative group/card  dark:hover:shadow-2xl dark:hover:shadow-emerald-500/[0.1] dark:bg-black dark:border-white/[0.2] border-black/[0.1] w-auto sm:w-[30rem] h-[50%] rounded-xl p-6 border  ">
        <CardItem
          translateZ="50"
          className="text-xl font-bold text-neutral-600 dark:text-white">
          Towels that Feel Weightless
        </CardItem>
        <CardItem
          as="p"
          translateZ="60"
          className="text-neutral-500 text-md max-w-sm mt-2 dark:text-neutral-300">
          Like this card floats, our towels bring effortless softness every day.
        </CardItem>
        <CardItem translateZ="100" className="w-full mt-4 pb-16">
          <img
            src={motionimg}
            height="400"
            width="1000"
            className="h-60 w-full object-cover rounded-xl group-hover/card:shadow-xl"
            alt="thumbnail"
          />
        </CardItem>
        
      </CardBody>
    </CardContainer>
  );
};

export default MotionCard;
